interface TreasuryHubLogoProps {
  size?: number
  className?: string
}

/**
 * TreasuryHub brand mark — stylized "FH" in white on a gold disc.
 */
export function TreasuryHubLogo({ size = 56, className }: TreasuryHubLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72"
      role="img"
      aria-label="TreasuryHub"
      className={className}
    >
      <circle cx="36" cy="36" r="34" fill="#B4975A" />
      <line x1="22" y1="20" x2="38" y2="20" stroke="white" strokeWidth="7" strokeLinecap="round" />
      <line x1="22" y1="20" x2="22" y2="52" stroke="white" strokeWidth="7" strokeLinecap="round" />
      <line x1="50" y1="20" x2="50" y2="52" stroke="white" strokeWidth="7" strokeLinecap="round" />
      <line x1="34" y1="36" x2="50" y2="36" stroke="white" strokeWidth="7" strokeLinecap="round" />
    </svg>
  )
}

interface TreasuryHubWordmarkProps {
  height?: number
  className?: string
  /** Kept for API compatibility — the mark is theme-independent so this is now a no-op. */
  variant?: 'auto' | 'white' | 'black'
}

/**
 * TreasuryHub iso logo — FH icon + "TreasuryHub" wordmark rendered in brand type. 
 */
export function TreasuryHubWordmark({ height = 14, className }: TreasuryHubWordmarkProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ''}`}>
      <TreasuryHubLogo size={height} />
      <span
        className="font-brand font-semibold tracking-[-0.3px]"
        style={{ fontSize: height }}
      >
        Treasury<span className="text-primary">Hub</span>
      </span>
    </span>
  )
}
